export function YesChefLogo() {
  return (
    <img
      src="/YesChefLogo.png"
      alt="Yes, Chef!"
      className="h-10 w-auto"
      loading="eager"
      decoding="async"
    />
  );
}
